const langsElements = document.querySelectorAll(".langs");

langsElements.forEach(item => item.addEventListener("click", openLangs));

function openLangs(e) {
    e.stopPropagation();

    // Закрываем все остальные открытые языковые меню
    langsElements.forEach(lang => {
        if (lang !== e.currentTarget) {
            lang.classList.remove("active");
        }
    });

    // Переключаем текущее меню
    e.currentTarget.classList.toggle("active");

    // Добавляем обработчик для закрытия при клике вне меню
    document.body.addEventListener("click", closeLangsOnOutsideClick);
}

function closeLangsOnOutsideClick(e) {
    if (!e.target.closest(".langs")) {
        // Закрываем все языковые меню
        langsElements.forEach(lang => lang.classList.remove("active"));
        document.body.removeEventListener("click", closeLangsOnOutsideClick);
    }
}
